// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.background-video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: hidden;
}

.background-video {
  width: 100vw;
  height: 100vh;
  border: none;
  pointer-events: none;
}

.content-overlay {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, rgba(29, 17, 54, 0.8), rgba(87, 52, 164, 0.8));
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

/* Hide video on mobile and small screens */
@media (max-width: 768px) {
  .background-video-container {
    display: none;
  }

  .content-overlay {
    background: linear-gradient(135deg, #1D1136, #5734A4);
  }
}

.home h1 {
  margin-bottom: 1rem;
  font-size: 2.5rem;
}

.home p {
  margin: 0.5rem 0;
  font-size: 1.2rem;
  max-width: 600px;
  line-height: 1.6;
}

.home img {
  max-width: 200px;
  margin-top: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.join-button {
  display: inline-block;
  background: #481CAF;
  color: white;
  text-decoration: none;
  padding: 1.2rem 3rem;
  border-radius: 50px;
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 2rem;
  box-shadow: 0 8px 25px rgba(72, 28, 175, 0.4);
  transition: all 0.3s ease;
  border: 3px solid #481CAF;
}

.join-button:hover {
  background: #3a158f;
  border-color: #3a158f;
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(72, 28, 175, 0.6);
  text-decoration: none;
  color: white;
}

.book-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  gap: 1rem;
}

.book-link {
  display: inline-block;
  transition: transform 0.3s ease;
}

.book-link:hover {
  transform: scale(1.02);
}

.book-image {
  max-width: 200px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.book-image:hover {
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
}

.order-button {
  display: inline-block;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
  transition: all 0.3s ease;
  border: 2px solid #ff6b35;
}

.order-button:hover {
  background: linear-gradient(135deg, #e55a2b, #e8851a);
  border-color: #e55a2b;
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.6);
  text-decoration: none;
  color: white;
}

.book-title {
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.youtube-section {
  margin-top: 4rem;
  text-align: center;
}

.youtube-link {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #ff0000, #cc0000);
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.1rem;
  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);
  transition: all 0.3s ease;
  border: 2px solid #ff0000;
}

.youtube-link:hover {
  background: linear-gradient(135deg, #cc0000, #aa0000);
  border-color: #cc0000;
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(255, 0, 0, 0.6);
  text-decoration: none;
  color: white;
}

.youtube-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.youtube-link:hover .youtube-icon {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.play-icon {
  font-size: 1.2rem;
  color: white;
  margin-left: 2px; /* Adjust play button position */
}

.youtube-text {
  white-space: nowrap;
}

.links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.link {
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  text-decoration: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  font-weight: 500;
}

.link:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 12px rgba(0,0,0,0.2);
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,kFAAkF;EAClF,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;;EAEA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC","sourcesContent":[".home {\n  position: relative;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.background-video-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.background-video {\n  width: 100vw;\n  height: 100vh;\n  border: none;\n  pointer-events: none;\n}\n\n.content-overlay {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, rgba(29, 17, 54, 0.8), rgba(87, 52, 164, 0.8));\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n/* Hide video on mobile and small screens */\n@media (max-width: 768px) {\n  .background-video-container {\n    display: none;\n  }\n\n  .content-overlay {\n    background: linear-gradient(135deg, #1D1136, #5734A4);\n  }\n}\n\n.home h1 {\n  margin-bottom: 1rem;\n  font-size: 2.5rem;\n}\n\n.home p {\n  margin: 0.5rem 0;\n  font-size: 1.2rem;\n  max-width: 600px;\n  line-height: 1.6;\n}\n\n.home img {\n  max-width: 200px;\n  margin-top: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.join-button {\n  display: inline-block;\n  background: #481CAF;\n  color: white;\n  text-decoration: none;\n  padding: 1.2rem 3rem;\n  border-radius: 50px;\n  font-size: 1.4rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-top: 2rem;\n  box-shadow: 0 8px 25px rgba(72, 28, 175, 0.4);\n  transition: all 0.3s ease;\n  border: 3px solid #481CAF;\n}\n\n.join-button:hover {\n  background: #3a158f;\n  border-color: #3a158f;\n  transform: translateY(-3px);\n  box-shadow: 0 12px 35px rgba(72, 28, 175, 0.6);\n  text-decoration: none;\n  color: white;\n}\n\n.book-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 3rem;\n  gap: 1rem;\n}\n\n.book-link {\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n\n.book-link:hover {\n  transform: scale(1.02);\n}\n\n.book-image {\n  max-width: 200px;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.book-image:hover {\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);\n}\n\n.order-button {\n  display: inline-block;\n  background: linear-gradient(135deg, #ff6b35, #f7931e);\n  color: white;\n  text-decoration: none;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);\n  transition: all 0.3s ease;\n  border: 2px solid #ff6b35;\n}\n\n.order-button:hover {\n  background: linear-gradient(135deg, #e55a2b, #e8851a);\n  border-color: #e55a2b;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(255, 107, 53, 0.6);\n  text-decoration: none;\n  color: white;\n}\n\n.book-title {\n  color: white;\n  font-size: 1.4rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.youtube-section {\n  margin-top: 4rem;\n  text-align: center;\n}\n\n.youtube-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: linear-gradient(135deg, #ff0000, #cc0000);\n  color: white;\n  text-decoration: none;\n  padding: 1rem 2rem;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1.1rem;\n  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);\n  transition: all 0.3s ease;\n  border: 2px solid #ff0000;\n}\n\n.youtube-link:hover {\n  background: linear-gradient(135deg, #cc0000, #aa0000);\n  border-color: #cc0000;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(255, 0, 0, 0.6);\n  text-decoration: none;\n  color: white;\n}\n\n.youtube-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.youtube-link:hover .youtube-icon {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.play-icon {\n  font-size: 1.2rem;\n  color: white;\n  margin-left: 2px; /* Adjust play button position */\n}\n\n.youtube-text {\n  white-space: nowrap;\n}\n\n.links {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.link {\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  text-decoration: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.link:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 12px rgba(0,0,0,0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
